import React from 'react';
import Header from '../components/ui/Header';
import Footer from './ac-service-landing-page/components/Footer';

const Sitemap = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-12 lg:py-20">
        <h1 className="text-4xl font-bold text-center mb-4 text-foreground">Sitemap</h1>
        <div className="w-24 h-1 bg-primary mx-auto mb-12 rounded-full"></div> {/* Decorative divider */}
        <div className="prose prose-lg mx-auto max-w-3xl p-6 sm:p-8 border border-gray-200 rounded-lg shadow-sm">
          <p className="text-base text-muted-foreground mb-4">Berikut adalah daftar halaman utama yang tersedia di situs kami:</p>
          <ul className="list-disc list-outside ml-5 text-base text-muted-foreground space-y-2">
            <li><a href="/" className="text-primary hover:underline">Beranda</a></li>
            <li><a href="/ac-service-landing-page" className="text-primary hover:underline">Halaman Layanan AC</a></li>
            <li><a href="/privacy-policy" className="text-primary hover:underline">Kebijakan Privasi</a></li>
            <li><a href="/terms-and-conditions" className="text-primary hover:underline">Syarat & Ketentuan</a></li>
            <li><a href="/sitemap" className="text-primary hover:underline">Sitemap</a></li>
            <li><a href="/404" className="text-primary hover:underline">Halaman Tidak Ditemukan (404)</a></li>
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Sitemap;